<template>
  <b-modal
    id="loteModal"
    ref="modalLote"
    :title="compra ? 'Lote da compra' : 'Selecionar lote'"
    hide-footer
    size="lg"
  >
    <b-row v-if="compra" class="mb-3">
      <b-col>
        <b-form-radio-group
          v-model="modoLote"
          :options="opcoesModoLote"
          buttons
          button-variant="outline-primary"
        />
      </b-col>
    </b-row>

    <b-row>
      <b-col md="8">
        <p>
          <strong>Produto:</strong> {{ produto?.descricao || "Não informado" }}
        </p>

        <b-row v-if="modoLote === 'existente'">
          <b-col>
            <b-alert v-if="produto?.baixa_automatica_lote" variant="info" show>
              <strong>Atenção:</strong> Este produto está configurado para baixa
              automática de lotes. O sistema selecionará automaticamente o lote
              com vencimento mais próximo.
            </b-alert>
          </b-col>
        </b-row>

        <b-form-group
          v-if="modoLote === 'existente'"
          label="Pesquisar Número do Lote"
        >
          <b-form-input v-model="filtroLote" placeholder="Digite o número do lote..." debounce="300" />
        </b-form-group>

        <div v-if="modoLote === 'existente'" :style="{
          maxHeight: lotesFiltrados.length > 5 ? '300px' : 'auto',
          overflowY: lotesFiltrados.length > 5 ? 'scroll' : 'visible',
        }">
          <b-table striped hover bordered :items="loading ? [] : lotesFiltrados" :fields="campos" select-mode="single"
            selectable @row-selected="selecionarLote" :busy="loading">
            <template #table-busy>
              <div class="text-center my-3">
                <b-spinner variant="primary" label="Carregando..."></b-spinner>
                <p>Carregando lotes...</p>
              </div>
            </template>

            <template #cell(data_fabricacao)="row">
              {{ formatDate(row.item.data_fabricacao) }}
            </template>

            <template #cell(data_validade)="row">
              {{ formatDate(row.item.data_validade) }}
            </template>

            <template #cell(quantidade)="row">
              <span :class="{ 'text-danger': row.item.quantidade <= 0 }">
                {{ numberToReal(row.item.quantidade, "quantidade") }}
                <span v-if="row.item.quantidade <= 0"> (Sem estoque)</span>
              </span>
            </template>
          </b-table>
        </div>

        <div v-else>
          <b-alert variant="info" show>
            Cadastre o lote que receberá a quantidade desta compra.
          </b-alert>
          <b-form-group label="Número do lote" label-for="novo-numero-lote">
            <b-form-input
              id="novo-numero-lote"
              v-model.trim="novoLote.numero_lote"
              maxlength="50"
              placeholder="Informe o número do lote"
            />
          </b-form-group>
          <b-row>
            <b-col md="6">
              <b-form-group label="Data de fabricação" label-for="novo-lote-fabricacao">
                <b-form-datepicker
                  id="novo-lote-fabricacao"
                  v-model="novoLote.data_fabricacao"
                  locale="pt-br"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Data de validade" label-for="novo-lote-validade">
                <b-form-datepicker
                  id="novo-lote-validade"
                  v-model="novoLote.data_validade"
                  locale="pt-br"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-col>

      <!-- Indicação do lote selecionado -->
      <b-col md="4">
        <b-alert v-if="modoLote === 'novo' && novoLote.numero_lote" show variant="success">
          <p><strong>Novo lote:</strong> {{ novoLote.numero_lote }}</p>
          <p v-if="novoLote.data_validade">
            <strong>Validade:</strong> {{ formatDate(novoLote.data_validade) }}
          </p>
        </b-alert>

        <b-alert v-else-if="loteSelecionado" show variant="success">
          <p>
            <strong>Lote Selecionado:</strong> {{ loteSelecionado.numero_lote }}
          </p>
          <p>
            <strong>Validade:</strong>
            {{ formatDate(loteSelecionado.data_validade) }}
          </p>
          <p>
            <strong>Disponível:</strong>
            {{ numberToReal(loteSelecionado.quantidade, "quantidade") }}
            unidades
          </p>
        </b-alert>

        <b-alert v-else show variant="warning">
          Nenhum lote selecionado
        </b-alert>

        <b-form-group :label="compra ? 'Quantidade a alimentar' : 'Quantidade'">
          <money :disabled="bloquearQuantidade || (modoLote === 'existente' && !loteSelecionado)" class="form-control" v-model="quantidadeSelecionada"
            v-bind="quantityOptions" min="1" :max="!compra && loteSelecionado && loteSelecionado.quantidade > 0 ? loteSelecionado.quantidade : null">
          </money>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col>
        <b-button variant="secondary" @click="fecharModal">Cancelar</b-button>
        <b-button variant="primary" :disabled="!podeConfirmar"
          @click="confirmarSelecao">
          Confirmar
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>
<script>
import { SistemaMixin } from "@/modules/Application";
import { quantityOptions } from "@/modules/Application";
import { Money } from "v-money";
import { criarLoteNovoCompra } from "@/modules/Compras/loteCompra";

export default {
  name: "LoteModal",
  mixins: [SistemaMixin],
  components: {
    Money,
  },
  props: {
    produto: {
      type: Object,
      default: null,
    },
    addProduto: {
      type: Function,
    },
    compra: {
      type: Boolean,
    },
    atualizarLotes: {
      type: Number,
    },
    preco: {
      type: Number,
      default: 0,
    },
    quantidade: {
      type: [Number, String],
      default: 1,
    },
    bloquearQuantidade: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      filtroLote: "",
      quantityOptions,
      lotes: [],
      loteSelecionado: null,
      quantidadeSelecionada: 1,
      modoLote: "existente",
      opcoesModoLote: [
        { text: "Selecionar lote existente", value: "existente" },
        { text: "Cadastrar novo lote", value: "novo" },
      ],
      novoLote: {
        numero_lote: "",
        data_fabricacao: null,
        data_validade: null,
      },
      campos: [
        { key: "numero_lote", label: "Lote" },
        { key: "data_fabricacao", label: "Fabricação" },
        { key: "data_validade", label: "Validade" },
        { key: "quantidade", label: "Disponível" },
      ],
    };
  },
  watch: {
    atualizarLotes(value) {
      this.abrirModal();
    },
  },
  computed: {
    podeConfirmar() {
      const possuiLote = this.modoLote === "novo"
        ? Boolean(this.novoLote.numero_lote?.trim())
        : Boolean(this.loteSelecionado);

      return possuiLote && Number(this.quantidadeSelecionada) > 0;
    },
    lotesFiltrados() {
      let lotes = [...this.lotes];

      lotes = lotes
        .sort((a, b) => new Date(a.data_validade) - new Date(b.data_validade));

      if (this.filtroLote) {
        return lotes.filter((lote) =>
          lote.numero_lote.toLowerCase().includes(this.filtroLote.toLowerCase())
        );
      }

      return lotes;
    },
  },
  methods: {
    selecionarLote(selecionado) {
      if (selecionado.length === 0) {
        this.loteSelecionado = null;
        this.quantidadeSelecionada = 0;
        return;
      }

      const lote = selecionado[0];

      this.loteSelecionado = lote;
      this.quantidadeSelecionada = 1;
    },
    confirmarSelecao() {
      if (!this.compra && this.modoLote === "existente") {
        if (
          this.loteSelecionado.quantidade < this.quantidadeSelecionada
        ) {
          this.$toast.warning(
            "Quantidade informada maior que a do lote selecionado!"
          );
          return;
        }
      }

      if (this.podeConfirmar) {
        const loteSelecionado = this.modoLote === "novo"
          ? criarLoteNovoCompra(this.novoLote, this.quantidadeSelecionada)
          : this.loteSelecionado;

        // Cria uma cópia do lote sem mutar o original
        const loteBaixa = {
          ...loteSelecionado,
          quantidade_original: this.modoLote === "novo"
            ? 0
            : loteSelecionado.quantidade,
          quantidade: this.numberToReal(this.quantidadeSelecionada),
        };
        
        // Cria um novo objeto produto sem mutar a prop
        const produtoAtualizado = {
          ...this.produto,
          lote_baixa: loteBaixa,
          preco: this.formatNumberToFloat(this.produto.preco),
          quantidade: this.quantidadeSelecionada,
        };

        // Usa o preco vindo da prop (preço digitado no form principal) se disponível
        const precoUtilizado = this.preco > 0 ? this.preco : this.formatNumberToFloat(this.produto.preco);
        const totalCalculado = precoUtilizado * this.quantidadeSelecionada;

        this.$emit("onAddProduto", {
          newPreco: precoUtilizado,
          newQuantidade: this.quantidadeSelecionada,
          newTotal: totalCalculado,
          newProduto: produtoAtualizado,
        });

        this.fecharModal();
      }
    },
    async abrirModal() {
      if (!this.produto?.id) return;
      
      this.$nextTick(() => {
        if (this.$refs.modalLote) {
          this.$refs.modalLote.show();
        }
      });
      this.loading = true;
      this.loteSelecionado = null;
      this.modoLote = "existente";
      this.novoLote = {
        numero_lote: "",
        data_fabricacao: null,
        data_validade: null,
      };
      this.quantidadeSelecionada = Number(this.quantidade) > 0
        ? Number(this.quantidade)
        : 1;

      try {
        const response = await this.$http.post("/produtos/get-lote", {
          id_produto: this.produto.id,
          compra: this.compra,
        });

        this.lotes = response.data || [];
        this.loading = false;

        if (this.compra && this.lotes.length === 0) {
          this.modoLote = "novo";
        }

        if (
          this.produto?.baixa_automatica_lote &&
          this.lotesFiltrados.length > 0
        ) {
          this.loteSelecionado = this.lotesFiltrados[0];
          this.quantidadeSelecionada = 1;
          this.$toast.success(
            `Lote ${this.loteSelecionado.numero_lote} foi sugerido automaticamente!`
          );
        }
      } catch (error) {
        this.$toast.error("Erro ao carregar lotes do servidor.");
        this.loading = false;
      }
    },
    fecharModal() {
      this.loteSelecionado = null;
      this.quantidadeSelecionada = 0;
      this.filtroLote = "";
      this.modoLote = "existente";
      this.novoLote = {
        numero_lote: "",
        data_fabricacao: null,
        data_validade: null,
      };
      this.$refs.modalLote.hide();
      this.$emit("onClose");
    },
  },
};
</script>
